import { isToday, parseISO } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";

export const formatArticleDate = (date: string | null | undefined) => {
  if (!date) return "";
  const dateInstance = parseISO(date);
  const nyTimeZone = "America/New_York";

  try {
    const nyDate = utcToZonedTime(dateInstance, nyTimeZone);

    if (isToday(dateInstance)) {
      return `${format(nyDate, "h:mm aaa", {
        timeZone: nyTimeZone,
      })} ET`;
    }
  } catch (err) {
    console.error("Timestamp err", err);
  }

  return format(dateInstance, "MMMM d, y");
};

export const formatArticleUpdatedDate = (date: string | null | undefined) => {
  if (!date) return "";
  const dateInstance = parseISO(date);
  const nyTimeZone = "America/New_York";

  try {
    const nyDate = utcToZonedTime(dateInstance, nyTimeZone);
    const time = `${format(nyDate, "h:mm aaa", {
      timeZone: nyTimeZone,
    })} ET`;

    return isToday(dateInstance)
      ? time
      : `${time} on ${format(nyDate, "MMMM d, y", {
          timeZone: nyTimeZone,
        })}`;
  } catch (err) {
    console.error("'Updated at' timestamp err", err);
  }
};
